<template lang="pug">
  .table-responsive
    table#tbMovimientos.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Fecha Reg.
          th 
            | Restante
          th 
            | Extra
          th 
            | Km. Inicio
          th 
            | Carga Pesos
          th 
            | Carga Litros
          th 
            | Costo
          th 
            | Km. Final
          th 
            | Kms. Rec.
          th 
            | Consumo
          th 
            | Calidad
          th 
            | Observaciones
      tbody
        tr(v-for="(mov, index) in movs" :key="mov.id")
          td.is-size-7
            a.button.is-black.is-rounded.is-small {{ index + 1 }}
          td.is-size-7
            | {{ mov.fecha }}
          td.is-size-7
            span.tag
              | {{ mov.restante | currency }}
          td.is-size-7(v-if="mov.asig_extra <= 0")
            |
          td.is-size-7(v-else)
            span.tag.is-black
              | {{ mov.asig_extra | currency }}
          td.is-size-7(v-if="parseInt(mov.km_inicio) == 0 || mov.km_inicio===''")
            | 
          td.is-size-7(v-else)
            .columns
              .column.is-12
                span.tag.is-black
                  | {{ mov.km_inicio }}
          td.is-size-7(v-if="mov.cargaPesos <= 0 ")
            | 
          td.is-size-7(v-else)
            span.tag.is-danger
              | {{ mov.cargaPesos | currency }}
          td.is-size-7(v-if="parseInt(mov.cargaLitros) == 0 ")
            | 
          td.is-size-7(v-else)
            span.tag.is-light
              | {{ mov.cargaLitros }}
          td.is-size-7(v-if="mov.costoLitro <= 0 || mov.costoLitro === ''")
            | 
          td.is-size-7(v-else)
            span.tag.is-light
              | {{ mov.costoLitro | currency }}
          td.is-size-7(v-if="parseInt(mov.km_fin) == 0 ")
            |
          td.is-size-7(v-else)
            span.tag.is-dark
              | {{ mov.km_fin }}
          td.is-size-7(v-if="parseInt(mov.km_rec) == 0 ")
            |
          td.is-size-7(v-else)
            span.tag.is-info
              | {{ mov.km_rec }}
          td.is-size-7(v-if="parseInt(mov.consumo) == 0 ")
            |
          td.is-size-7(v-else)
            | {{ mov.consumo }}
          td.is-size-7
            | {{ mov.calidad }}
          td.is-size-7
            span(v-html="getDataObservacion(mov)")
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  export default {
    name: 'TbMovimientos',
    props: {
      movs: {
        type: Array,
        default: []
      },
      movSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: false,
        itemsSelected: {},
        isDisabled: true,
        asigMensual: 0,
      }
    },
    watch: {
      movs() {
        this.checkDatos()  
      },
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      movSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.movSel)
      },
    },
    methods: {
      iniciarComponente () {
        console.log(this.movSel)
        this.checkDatos()
      },
      checkDatos () {
        if (this.movs.length > 0) {
          this.asigMensual = parseFloat(this.movs[0].asig_mensual)
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      getKey(campo, mov) {
        let id = `${campo}_${mov.id}`
        console.log(id)
        return id
      },
      submit(e, campo, mov) {
        console.log(e.target)
        console.log(campo)
        console.log(mov)
      },
      cancel(e, mov) {
        console.log(e)
        console.log(mov)
      },
      edit(campo, mov,) {

      },
      getDataObservacion (data) {
        let htmlResult = ''
        htmlResult = data.observaciones === '' ? '': `<span class='tag is-dark'>${data.observaciones}</span>`
        return htmlResult
      }
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/TbMovimientos.vue